var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"component work-menu-top"},[_c('el-tabs',{model:{value:(_vm.currentMenu),callback:function ($$v) {_vm.currentMenu=$$v},expression:"currentMenu"}},_vm._l((_vm.workTopMenu),function(item){return _c('el-tab-pane',{key:item.id,attrs:{"label":item.name,"name":item.id.toString()}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }